import { bindValidator } from './validators';
import store from './store';
import carrinhoSlice from "./slices/carrinhoSlice";
import Swal from 'sweetalert2';
import axios from 'axios';
import { reconciliarCarrinho } from './carrinhoSync';
import { redirectTo } from './navigation';

const form = document.querySelector<HTMLFormElement>('.compra__form');
const action = document.querySelector('.compra__action');

if (form) {
    const validator = bindValidator(form);
    let isSubmitting = false;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // Evita reenvio enquanto um pedido já está sendo processado (o cliente
        // costuma clicar várias vezes achando que não concluiu → pedido duplicado).
        if (isSubmitting) return;

        const valid = validator.validate();

        if(!valid) return;

        await Swal.fire({
            title: "Você deseja confirmar a sua compra?",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Sim, confirmar compra",
            cancelButtonText: "Não",
            cancelButtonColor: "#aaa",
        }).then(async (result) => {
            if (result.isConfirmed) {
                isSubmitting = true;
                try {
                    action?.classList.add('button--loading');

                    // Feedback bloqueante enquanto o pedido é processado no back
                    // (o envio do e-mail é síncrono e pode levar alguns segundos).
                    // Impede cliques no botão e deixa claro que algo está acontecendo.
                    Swal.fire({
                        title: 'Processando seu pedido…',
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });

                    const staleCount = await reconciliarCarrinho();
                    if (staleCount > 0) {
                        await Swal.fire({
                            icon: 'warning',
                            title: 'Produtos atualizados',
                            text: 'Produto desatualizado. Atualizamos o pacote no carrinho. Revise os itens destacados e confirme novamente.',
                            confirmButtonText: 'Entendi'
                        });
                        return;
                    }
                    const usuarioId = document.querySelector<HTMLInputElement>('input[name="usuario_id"]');
                    const nome = document.querySelector<HTMLInputElement>('input[name="nome"]');
                    const telefone = document.querySelector<HTMLInputElement>('input[name="telefone"]');

                    const data = {
                        produtos: store.getState().itens
                    }

                    await axios.post("/api/pedidos", usuarioId ? {
                        ...data,
                        usuario_id: usuarioId.value
                    } : {
                        ...data,
                        nome: nome?.value,
                        telefone: telefone?.value
                    }, {
                        withCredentials: true
                    });

                    const { limpar } = carrinhoSlice.actions;

                    store.dispatch(limpar({}));
                    redirectTo("/pedido-realizado");
                } catch (e) {
                    if (axios.isAxiosError(e) && e.response?.status === 422 && e.response?.data?.code === 'CART_ITEM_STALE_QUANTIDADE') {
                        await reconciliarCarrinho();
                        await Swal.fire({
                            icon: 'warning',
                            title: 'Produtos atualizados',
                            text: e.response.data.message || 'Produto desatualizado. Atualizamos o pacote no carrinho. Revise os itens destacados e confirme novamente.',
                            confirmButtonText: 'Entendi'
                        });
                        return;
                    }
                    console.error(e);
                    await Swal.fire({
                        icon: 'error',
                        title: 'Não foi possível concluir o pedido',
                        text: 'Tente novamente em instantes.',
                        confirmButtonText: 'Entendi'
                    });
                } finally {
                    action?.classList.remove('button--loading');
                    isSubmitting = false;
                }
            }
        });
    });

    action?.addEventListener('click', (e) => {
        const submit = new Event('submit', { cancelable: true });
        form.dispatchEvent(submit);
    })
}

const updateResumo = () => {
    const carrinho = store.getState();

    const quantidade = document.querySelector('.compra__quantidade');
    const total = document.querySelector('.compra__total');

    if (quantidade)
        quantidade.textContent = `Quantidade de itens: ${carrinho.itens.length}`

    let valor = 0;
    carrinho.itens.forEach(item => {
        valor += (item.quantidade_produto?.price || 0) * item.quantidade
    });

    if (total)
        total.textContent = valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

updateResumo();
store.subscribe(updateResumo);
reconciliarCarrinho().catch(() => null);
